import { format } from "date-fns";
import type { Address } from "../backend/clients/backendClient";

export class TextService {
  capitalize(str: string) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  toTitleCase(str: string) {
    if (!str) return "";
    return str.replace(/(^|\s|-)[a-záéíóöőúüű]/g, (match) =>
      match.toUpperCase()
    );
  }

  formatDate(date: Date | undefined, dateFormat: string) {
    if (!date) return "";
    return format(date, dateFormat);
  }

  formatSSN(ssn: string) {
    if (!ssn) return "";
    const digits = ssn.replace(/\D/g, "");
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 9)}`;
  }

  formatAddress(address?: Address): string {
    if (!address) return "";
    let postalCode = address.postalCode ? address.postalCode.toString() : "";
    let city = address.city ?? "";
    let streetAddress = address.streetAddress?.length
      ? address.streetAddress
      : `${address.publicAreaName} ${address.publicAreaType} ${address.houseNumber}`;
    return (postalCode + " " + city + " " + streetAddress).trim();
  }

  formatPhone(phone: string) {
    if (!phone) return "";
    const digits = phone.replace(/\D/g, "");
    if (digits.length < 2) return `+(${digits}`;
    if (digits.length < 4) return `+(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length < 7)
      return `+(${digits.slice(0, 2)}) ${digits.slice(2, 4)} ${digits.slice(
        4
      )}`;
    if (digits.length < 11)
      return `+(${digits.slice(0, 2)}) ${digits.slice(2, 4)} ${digits.slice(
        4,
        7
      )} ${digits.slice(7)}`;
    return `+(${digits.slice(0, 2)}) ${digits.slice(2, 4)} ${digits.slice(
      4,
      7
    )} ${digits.slice(7, 11)}`;
  }
}

export const textService = new TextService();
